import * as Linking from 'expo-linking';

export default {
  prefixes: [Linking.makeUrl('/'), 'auraapp://', 'http://aura.app'],
  config: {
    // Root: {
    //   path: 'root',
      screens: {
        MainMenu: 'home/:customArgument',
        WebBuyOnline: 'offers',
        Settings: 'userSettings',
        LoginModeChoice: 'loginchoice',
        SignUpModeChoice: 'signupchoice',
        ReferredSignUp: {
          path: 'ref/:referrer?'
        }
      },
    // },
  },
};
